import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";
export const linear: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-dir-lin-ka9-ha3.svg` },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-coeff-ka9-ha3.svg` },
      },
    },
  },
];
export const logarithmic: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-dir-db-ka9-ha3.svg` },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-square-coeff-ka9-ha3.svg` },
      },
    },
  },
];
